//@flow
import reducer from "./reducers";

import * as statusUpdateViewsOperations from "./operations";
import * as statusUpdateViewsSelectors from "./selectors";

export { statusUpdateViewsOperations, statusUpdateViewsSelectors };

export default reducer;
